// Stylized lighthouse icon. The tower inherits `currentColor`; the lamp, glow,
// and light beams are driven by CSS and switch on when `lit` is true (dark mode).
export default function Lighthouse({ lit = false, size = 26 }) {
  return (
    <svg
      className={`lighthouse${lit ? ' lit' : ''}`}
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      {/* Light beams — hidden until lit */}
      <g className="lh-beams">
        <polygon className="lh-beam" points="31,20 2,9 2,31" />
        <polygon className="lh-beam" points="33,20 62,9 62,31" />
      </g>

      {/* Glow halo around the lamp — hidden until lit */}
      <circle className="lh-glow" cx="32" cy="20" r="11" />

      {/* Structure (inherits currentColor) */}
      <g className="lh-structure">
        {/* finial + roof */}
        <line className="lh-line" x1="32" y1="3" x2="32" y2="6" />
        <polygon className="lh-solid" points="32,6 41,15 23,15" />
        {/* lamp housing */}
        <rect className="lh-solid" x="25" y="15" width="14" height="10" rx="1" />
        {/* the lamp itself */}
        <rect className="lh-lamp" x="28" y="17" width="8" height="6" rx="1" />
        {/* gallery deck */}
        <rect className="lh-solid" x="22" y="25" width="20" height="3" rx="1" />
        {/* tower */}
        <polygon className="lh-solid" points="25,28 39,28 44,56 20,56" />
        {/* tower band */}
        <polygon className="lh-band" points="23.6,40 40.4,40 41.7,48 22.3,48" />
        {/* base */}
        <rect className="lh-solid" x="16" y="56" width="32" height="4" rx="1" />
      </g>
    </svg>
  );
}
